module.exports = __webpack_public_path__ + "static/media/dots.3fd8845e.svg";